(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["krm-categories-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(!root || root.dataset.krmReady === '1') return;
      root.dataset.krmReady = '1';

      var track = root.querySelector('[data-krm-track]');
      if(!track) return;
      var prev  = root.querySelector('[data-krm-prev]');
      var next  = root.querySelector('[data-krm-next]');
      var dots  = root.querySelector('[data-krm-dots]');
      var timer = null;

      function step(){
        var slide = track.querySelector('.krm-cat');
        if(!slide) return track.clientWidth;
        var cs  = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }
      function maxScroll(){ return track.scrollWidth - track.clientWidth; }
      function pageCount(){ return Math.max(1, Math.ceil(maxScroll() / Math.max(1, track.clientWidth)) + 1); }
      function pageIndex(){ return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }

      function buildDots(){
        if(!dots) return;
        var n = pageCount();
        if(n < 2 || maxScroll() < 2){ dots.setAttribute('hidden',''); dots.innerHTML = ''; return; }
        dots.removeAttribute('hidden');
        if(dots.children.length !== n){
          dots.innerHTML = '';
          for(var i = 0; i < n; i++){
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'krm-carousel__dot';
            b.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
            b.dataset.index = i;
            b.addEventListener('click', function(){
              track.scrollTo({ left: this.dataset.index * track.clientWidth, behavior: 'smooth' });
              stopAuto();
            });
            dots.appendChild(b);
          }
        }
        syncDots();
      }
      function syncDots(){
        if(!dots || dots.hasAttribute('hidden')) return;
        var active = pageIndex();
        Array.prototype.forEach.call(dots.children, function(d, i){
          d.classList.toggle('is-active', i === active);
          d.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      }
      function syncArrows(){
        var m = maxScroll();
        [prev, next].forEach(function(btn){
          if(!btn) return;
          if(m < 2){ btn.setAttribute('hidden',''); } else { btn.removeAttribute('hidden'); }
        });
        if(prev) prev.disabled = track.scrollLeft <= 2;
        if(next) next.disabled = track.scrollLeft >= m - 2;
      }
      function sync(){ syncArrows(); syncDots(); }

      if(prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); stopAuto(); });
      if(next) next.addEventListener('click', function(){ track.scrollBy({ left:  step(), behavior: 'smooth' }); stopAuto(); });

      var ticking = false;
      track.addEventListener('scroll', function(){
        if(ticking) return;
        ticking = true;
        window.requestAnimationFrame(function(){ sync(); ticking = false; });
      }, { passive: true });

      function advance(){
        if(track.scrollLeft >= maxScroll() - 2){
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        }
      }
      function startAuto(){
        if(root.dataset.autoplay !== 'true') return;
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if(maxScroll() < 2) return;
        stopAuto();
        var ms = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
        timer = setInterval(advance, ms);
      }
      function stopAuto(){ if(timer){ clearInterval(timer); timer = null; } }

      root.addEventListener('mouseenter', stopAuto);
      root.addEventListener('focusin', stopAuto);
      root.addEventListener('touchstart', stopAuto, { passive: true });
      root.addEventListener('mouseleave', startAuto);
      document.addEventListener('visibilitychange', function(){ document.hidden ? stopAuto() : startAuto(); });

      track.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight'){ e.preventDefault(); track.scrollBy({ left:  step(), behavior: 'smooth' }); stopAuto(); }
        if(e.key === 'ArrowLeft'){  e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); stopAuto(); }
      });

      if(window.ResizeObserver){
        new ResizeObserver(function(){ buildDots(); sync(); }).observe(track);
      } else {
        window.addEventListener('resize', function(){ buildDots(); sync(); });
      }

      buildDots();
      sync();
      startAuto();
    }

    function initAll(scope){
      (scope || document).querySelectorAll('[data-krm-carousel]').forEach(init);
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krm-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.krm-fp__wrap[data-carousel="true"]').forEach(function(wrap){
      if(wrap.dataset.krmInit) return;
      wrap.dataset.krmInit = '1';
      var track = wrap.querySelector('[data-track]');
      var prev  = wrap.querySelector('.krm-fp__nav--prev');
      var next  = wrap.querySelector('.krm-fp__nav--next');
      if(!track) return;

      function step(){
        var card = track.firstElementChild;
        if(!card) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update(){
        var max = track.scrollWidth - track.clientWidth - 2;
        if(prev) prev.disabled = track.scrollLeft <= 2;
        if(next) next.disabled = track.scrollLeft >= max;
      }
      [prev,next].forEach(function(btn){
        if(!btn) return;
        btn.addEventListener('click', function(){
          track.scrollBy({ left: step() * parseInt(btn.dataset.dir,10), behavior:'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive:true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krm-header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var header = document.querySelector('.krm-header');
    if(header && header.getAttribute('data-shrink') === 'true'){
      window.addEventListener('scroll', function(){
        header.classList.toggle('is-shrunk', window.scrollY > 40);
      }, { passive:true });
    }

    var scrim  = document.getElementById('krm-scrim');
    var drawer = document.getElementById('krm-drawer');
    var burger = document.getElementById('krm-burger');
    var closeB = document.getElementById('krm-drawer-close');
    function openM(){ if(drawer){drawer.classList.add('is-open');} if(scrim){scrim.classList.add('is-open');} }
    function closeM(){ if(drawer){drawer.classList.remove('is-open');} if(scrim){scrim.classList.remove('is-open');} }
    if(burger) burger.addEventListener('click', openM);
    if(closeB) closeB.addEventListener('click', closeM);
    if(scrim)  scrim.addEventListener('click', closeM);

    var sToggle = document.getElementById('krm-search-toggle');
    var sPanel  = document.getElementById('krm-search');
    if(sToggle && sPanel){
      sToggle.addEventListener('click', function(){
        var open = sPanel.classList.toggle('is-open');
        sToggle.setAttribute('aria-expanded', open);
        if(open){ var i = sPanel.querySelector('input'); if(i) i.focus(); }
      });
    }

    document.addEventListener('keyup', function(e){
      if(e.key !== 'Escape') return;
      if(sPanel) sPanel.classList.remove('is-open');
      closeM();
      var a = document.activeElement;
      if(a && a.closest && a.closest('.krm-mega')){
        var t = a.closest('li').querySelector('.krm-nav__trigger');
        if(t) t.focus();
      }
    });

    function krmSetCount(n){
      var el = document.querySelector('[data-krm-cart-count]');
      if(el){
        el.textContent = n;
        if(n > 0){ el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); }
      }
      var link = document.getElementById('krm-cart-link');
      if(link) link.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + ' items' : 'Cart');
    }
    function krmRefreshCart(){
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      fetch(root + 'cart.js', { headers:{ 'Accept':'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(c){ krmSetCount(c.item_count); })
        .catch(function(){});
    }
    ['cart:update','cart:refresh','cart:change','cart-update'].forEach(function(ev){
      document.addEventListener(ev, krmRefreshCart);
    });
    if(window.fetch){
      var krmFetch = window.fetch;
      window.fetch = function(){
        var res = krmFetch.apply(this, arguments);
        try{
          var a = arguments[0];
          var url = typeof a === 'string' ? a : (a && a.url) || '';
          if(/\/cart\/(add|change|update|clear)/.test(url)){
            res.then(function(){ setTimeout(krmRefreshCart, 80); });
          }
        }catch(e){}
        return res;
      };
    }
    if(window.XMLHttpRequest){
      var krmOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(method, url){
        try{
          if(typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)){
            this.addEventListener('load', function(){ setTimeout(krmRefreshCart, 80); });
          }
        }catch(e){}
        return krmOpen.apply(this, arguments);
      };
    }
    krmRefreshCart();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krm-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.krm-hero[data-section-id]').forEach(function(hero){
      initHero(hero);
    });

    function initHero(hero){
      if(hero.dataset.krmInit) return;
      hero.dataset.krmInit = '1';
    var count = parseInt(hero.dataset.count || '0', 10);
    var track = hero.querySelector('.krm-hero__track');
    if(!track || count < 1) return;

    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.krm-hero__dot'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var pos = 0;
    var animating = false;

    if(count > 1){
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[count - 1].cloneNode(true);
      firstClone.setAttribute('aria-hidden','true');
      lastClone.setAttribute('aria-hidden','true');
      track.appendChild(firstClone);
      track.insertBefore(lastClone, slides[0]);
      pos = 1;
      setX(false);
    }

    function setX(animate){
      track.classList.toggle('no-anim', !animate || reduce);
      track.style.transform = 'translateX(' + (-pos * 100) + '%)';
      if(!animate || reduce){ void track.offsetWidth; }
    }
    function syncDots(){
      dots.forEach(function(d,i){ d.classList.toggle('is-active', i === ((index%count)+count)%count); });
    }
    function go(dir){
      if(count < 2 || animating) return;
      animating = true;
      pos += dir; index += dir;
      setX(true);
    }
    function toIndex(i){
      if(count < 2 || animating || i === index) return;
      animating = true;
      pos = i + 1; index = i;
      setX(true);
      syncDots();
    }

    track.addEventListener('transitionend', function(){
      animating = false;
      if(count < 2) return;
      if(pos === count + 1){ pos = 1; index = 0; setX(false); }
      else if(pos === 0){ pos = count; index = count - 1; setX(false); }
      index = ((index%count)+count)%count;
      syncDots();
    });

    var prev = hero.querySelector('.krm-hero__arrow--prev');
    var next = hero.querySelector('.krm-hero__arrow--next');
    if(prev) prev.addEventListener('click', function(){ stop(); go(-1); });
    if(next) next.addEventListener('click', function(){ stop(); go(1); });
    dots.forEach(function(d,i){ d.addEventListener('click', function(){ stop(); toIndex(i); }); });

    var startX = 0, dx = 0, dragging = false;
    function down(x){ if(count<2||animating) return; dragging = true; startX = x; dx = 0; track.classList.add('grabbing','no-anim'); }
    function move(x){ if(!dragging) return; dx = x - startX; track.style.transform = 'translateX(calc(' + (-pos*100) + '% + ' + dx + 'px))'; }
    function up(){ if(!dragging) return; dragging = false; track.classList.remove('grabbing'); var t = hero.clientWidth * 0.18;
      if(dx <= -t){ go(1); } else if(dx >= t){ go(-1); } else { setX(true); } stop(); }
    hero.addEventListener('pointerdown', function(e){ down(e.clientX); });
    window.addEventListener('pointermove', function(e){ move(e.clientX); });
    window.addEventListener('pointerup', up);
    hero.addEventListener('dragstart', function(e){ e.preventDefault(); });

    var timer = null;
    var play = hero.dataset.autoplay === 'true' && count > 1 && !reduce;
    var interval = Math.max(2, parseInt(hero.dataset.interval || '6', 10)) * 1000;
    function start(){ if(play && !timer){ timer = setInterval(function(){ go(1); }, interval); } }
    function stop(){ if(timer){ clearInterval(timer); timer = null; } setTimeout(start, interval); }
    hero.addEventListener('mouseenter', function(){ if(timer){ clearInterval(timer); timer = null; } });
    hero.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function(){ if(document.hidden){ if(timer){clearInterval(timer);timer=null;} } else start(); });
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krm-promises"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.krm-promises').forEach(function(root){
      if(root.dataset.krmInit) return;
      root.dataset.krmInit = '1';
      var track = root.querySelector('[data-track]');
      var dotsWrap = root.querySelector('[data-dots]');
      if(!track || !dotsWrap) return;
      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('button'));
      var items = Array.prototype.slice.call(track.children);

      dots.forEach(function(dot,i){
        dot.addEventListener('click', function(){
          if(items[i]) items[i].scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'});
        });
      });

      function sync(){
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        items.forEach(function(el,i){
          var c = el.offsetLeft + el.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if(d < bestDist){ bestDist = d; best = i; }
        });
        dots.forEach(function(d,i){ d.classList.toggle('is-active', i === best); });
      }
      track.addEventListener('scroll', sync, { passive:true });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
